(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('VoucherSaleConfirmationDialogController', VoucherSaleConfirmationDialogController);

    VoucherSaleConfirmationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VoucherSaleConfirmation', 'VobeUser', 'VoucherSale'];

    function VoucherSaleConfirmationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VoucherSaleConfirmation, VobeUser, VoucherSale) {
        var vm = this;

        vm.voucherSaleConfirmation = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.vobeusers = VobeUser.query();
        vm.vouchersales = VoucherSale.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.voucherSaleConfirmation.id !== null) {
                VoucherSaleConfirmation.update(vm.voucherSaleConfirmation, onSaveSuccess, onSaveError);
            } else {
                VoucherSaleConfirmation.save(vm.voucherSaleConfirmation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('vobeApp:voucherSaleConfirmationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdAt = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
